import { useEffect } from 'react';
import { setFavicon, setPageTitle } from '@hotjar/webapp/utils/document';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const favicon = require('@hotjar/shared-assets/icons/favicon.ico');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const pendingFavicon = require('@hotjar/shared-assets/icons/favicon-pending.ico');

const decoratePageTitle = (title: string) => `${title} - Hotjar`;

export function useWindowTitle(title: string): void {
  useEffect(() => {
    setPageTitle(decoratePageTitle(title));
    setFavicon(favicon);
  }, [title]);
}

export function useWindowTitleWithBlur(title: string, blurTitle: string): void {
  useWindowTitle(title);
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (window.document.visibilityState === 'visible') {
        setPageTitle(decoratePageTitle(title));
        setFavicon(favicon);
      } else {
        setPageTitle(decoratePageTitle(blurTitle));
        setFavicon(pendingFavicon);
      }
    };

    if (blurTitle) {
      window.document.addEventListener('visibilitychange', handleVisibilityChange);
    }

    return () => window.document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [title, blurTitle]);
}
